import { ArrowDownTrayIcon } from '@heroicons/react/24/outline';
import { Loader2 } from 'lucide-react';
import { DOWNLOAD_PREPARING_LABEL } from '../../constants/download.const';

/** A download button's icon and label, or a spinner and "Preparing…" while the file is fetched. */
export function DownloadLabel({
  pending,
  children
}: {
  pending: boolean;
  children: React.ReactNode;
}) {
  if (pending) {
    return (
      <>
        <Loader2 className="animate-spin" aria-hidden="true" />
        {DOWNLOAD_PREPARING_LABEL}
      </>
    );
  }
  return (
    <>
      <ArrowDownTrayIcon aria-hidden="true" />
      {children}
    </>
  );
}
